import { el, clear } from "./dom.js";
import { magSeriesMore } from "./magazine/detail.js";
import { navigate, rerenderRoute } from "../main.js";
import { getMovie, getMovieSeries } from "../api/movies.js";
import { addMovie, listMovies } from "../db/movies.js";
import { listGroups, createManualGroup, addItemToGroup } from "../db/groups.js";
import { showToast } from "./toast.js";

// Movies Phase 2 (roadmap #46): "More in this series" for a film, from
// Wikidata's film series — + Add one, or add them all as a collection named
// after the series. Filled in asynchronously; hidden when there's no series.

export function movieSeriesBlock(movie) {
	const wrap = el("div", {});
	if (!movie.imdb_id) return wrap;
	(async () => {
		try {
			const [series] = await getMovieSeries(movie.imdb_id);
			if (!series) return;
			const owned = new Map((await listMovies()).map((m) => [m.imdb_id, m.id]));
			const others = series.films.filter((f) => f.imdb_id !== movie.imdb_id);
			if (!others.length) return;
			clear(wrap);
			wrap.append(magSeriesMore("movie", {
				entries: others.map((f) => ({ title: f.title, year: f.year, cover_url: null, owned: owned.has(f.imdb_id), raw: f })),
				onAdd: async (e) => {
					await addFilm(e.raw);
					showToast(`Added “${e.raw.title}”`);
					rerenderRoute();
				},
				onAddAll: async () => {
					const ids = [];
					for (const f of series.films) ids.push(owned.get(f.imdb_id) ?? (await addFilm(f)).id);
					const group = await ensureCollection(series.name, ids);
					navigate(`/groups/${group.id}`);
				},
			}));
		} catch {
			// best-effort
		}
	})();
	return wrap;
}

async function addFilm(f) {
	const full = await getMovie(f.imdb_id);
	return addMovie({
		imdb_id: f.imdb_id,
		title: full.title ?? f.title,
		release_year: full.release_year ?? f.year ?? null,
		release_date: full.release_date ?? null,
		cover_url: full.cover_url ?? null,
		summary: full.summary ?? null,
		runtime: full.runtime ?? null,
		rated: full.rated ?? null,
		genres: full.genres ?? [],
		directors: full.directors ?? [],
		writers: full.writers ?? [],
		cast: full.cast ?? [],
		imdb_rating: full.imdb_rating ?? null,
	});
}

// Reuse a same-named movie collection, else make one.
async function ensureCollection(name, itemIds) {
	const existing = (await listGroups()).find((g) => g.media_type === "movie" && (g.name ?? "").toLowerCase() === name.toLowerCase());
	if (!existing) return createManualGroup({ name, media_type: "movie", member_ids: itemIds });
	for (const id of itemIds) await addItemToGroup(existing.id, id);
	return existing;
}
